import { createTheme } from '@mui/material/styles';
import type { SxProps, Theme as MuiTheme } from '@mui/material/styles';
import { foundation } from './foundation';
import { palette } from './palette';

const { black, white, offWhite, blue, success, error, warning } = palette.color;

export const muiTheme = createTheme({
  palette: {
    primary: { main: blue, contrastText: white },
    secondary: { main: black, contrastText: white },
    error: { main: error, contrastText: white },
    warning: { main: warning, contrastText: white },
    success: { main: success, contrastText: white },
    text: { primary: black },
    background: { default: offWhite, paper: white },
    common: { black, white },
  },
  typography: {
    fontFamily: foundation.font.family.base,
    button: {
      textTransform: 'none',
      fontWeight: Number(foundation.font.weight.semibold),
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        sizeLarge: {
          padding: `${foundation.space[4]} ${foundation.space[8]}`,
          fontSize: foundation.font.size.lg,
        },
      },
    },
  },
});

/** Outlined button for dark hero and CTA bands. */
export const glassButtonSx: SxProps<MuiTheme> = {
  color: white,
  borderWidth: 2,
  borderColor: palette.alpha.white[30],
  backgroundColor: palette.alpha.white[10],
  backdropFilter: `blur(${foundation.blur.sm})`,
  '&:hover': {
    color: white,
    borderWidth: 2,
    borderColor: palette.alpha.white[50],
    backgroundColor: palette.alpha.white[20],
  },
};

/** Solid light button used on dark call-to-action bands. */
export const inverseButtonSx: SxProps<MuiTheme> = {
  backgroundColor: white,
  color: black,
  '&:hover': {
    backgroundColor: offWhite,
    color: black,
  },
};
